import styled from 'styled-components';
import FooterImage from '../../../assets/images/saasModern/footer-bg.png';

const FooterWrapper = styled.footer`
  .orangeLink {
    color: #f16600;
    &:hover {
      text-decoration: underline;
    }
  }
  .whiteLink {
    color: #ffffff;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  .blackLink {
    color: #333333;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 50%, #1a1a1a 100%);
  .footer-tagline {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 5px;
    margin-bottom: 5px;
    font-weight: 400;
    letter-spacing: 0.02em;
  }

  .colOne {
    width: 23%;
    @media (max-width: 991px) {
      width: 35%;
    }
    @media (max-width: 575px) {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .colTwo {
    width: 77%;
    padding-bottom: 80px;
    margin-top: -50px;
    padding-top: 50px;
    background-repeat: no-repeat;
    background-position: center 0;
    background-image: url(${FooterImage});
    @media (max-width: 991px) {
      width: 65%;
    }
    @media (max-width: 575px) {
      width: 100%;
      padding-bottom: 50px;
    }
  }
  
  .footer_container {
    padding-top: 80px;
    padding-bottom: 0px;
    position: relative;
    z-index: 3;
  }
`;

const List = styled.ul``;

const ListItem = styled.li`
  a {
    color: rgba(52, 61, 72, 0.8);
    font-size: 14px;
    line-height: 36px;
    transition: all 0.2s ease;
    &:hover,
    &:focus {
      outline: 0;
      text-decoration: none;
      color: #343d48;
    }
  }
`;

export { List, ListItem };

export default FooterWrapper;
